import { useEffect, useReducer, useState } from "react";
import ProductDisplayMall from "./ProductDisplayMall";
import {
  mallEntriesByAgent,
  newallMallEntries,
  productFilterintialState,
  productFilterStateManage,
} from "./data";
import "./style/index.css";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import RemarksDialog from "./components/RemarksPopUp";
import AgreedProductPopUp from "./components/AgreedProductPopUp";
import { Box, Pagination, Skeleton, Typography } from "@mui/material";
import { useAuthData } from "../../../context/loginContext/LoginContextProvider";
import Swal from "sweetalert2";
import { deletemall } from "../api/mutation";
import { useLoading } from "../../../../context/LodingContext";
import ReconcileDialog from "../reconciledialog";
import { FiSearch } from "react-icons/fi";
import Grid from "@mui/material/Grid2";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import { allUsers } from "../api/query";
import MaterialSelect from "../../../../components/MasterSelect";
const ProductDisplayComplianceNew = ({
  tabValue,
  currentPage,
  setCurrentPage,
  isLoading,
  setIsLoading,
}) => {
  const [mallListData, setMallListData] = useState([]);
  const [remarksOpen, setRemarksOpen] = useState(false);
  const [recoilOpen, setRecoilOpen] = useState(false);
  const [recoilType, setRecoilType] = useState("");
  const [recoilData, setRecoilData] = useState(null);
  const [agreenProductOpen, setAgreenProductOpen] = useState(false);
  const [datas, setDatas] = useState(null);
  const { userId } = useAuthData();
  const { setCirleLoading } = useLoading();
  const [pageCount, setPageCount] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [filterData, dispatch] = useReducer(
    productFilterStateManage,
    productFilterintialState
  );
  const [allagentsOptions, setAllagentsOptions] = useState([]);
  useEffect(() => {
    fetchallusers();
  }, []);
  useEffect(() => {
    if (tabValue == "myentry") {
      fetchMallListByUser(currentPage, searchValue);
    } else {
      fetchMallListData(currentPage, searchValue);
    }
  }, [tabValue, currentPage, filterData]);

  const fetchMallListData = async (pageNumber, searchText = "") => {
    setIsLoading(true);
    try {
      const response = await request(BASEURL, newallMallEntries, {
        page: pageNumber,
        search: searchText,
        agentId: Number(filterData?.agentId?.value),
        startDate: filterData?.startDate,
        endDate: filterData?.endDate,
      });

      const data = response?.allMallEntries?.data;
      const totalPages = response?.allMallEntries?.totalPages;
      const success = response?.allMallEntries?.success;
      const totalCount = response?.allMallEntries?.totalCount;
      const message = response?.allMallEntries?.message;

      if (success) {
        setMallListData(data);
        setPageCount(totalPages);
      } else {
        setMallListData([]);

        Swal.fire({
          icon: "warning",
          title: "No Data Found",
          text: message || "Mall list data not available.",
          showCloseButton: true,
          confirmButtonColor: "#f0ad4e",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error Fetching Data",
        text: error.message || "Something went wrong while loading mall list.",
        showCloseButton: true,
        confirmButtonColor: "#d33",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchMallListByUser = async (pageNumber, searchText) => {
    setIsLoading(true);
    try {
      const response = await request(BASEURL, mallEntriesByAgent, {
        agentId: userId,
        page: pageNumber,
        search: searchText,
      });

      const data = await response?.mallEntriesByAgent?.data;
      const totalPages = await response?.mallEntriesByAgent?.totalPages;
      const success = await response?.mallEntriesByAgent?.success;
      const totalCount = await response?.mallEntriesByAgent?.totalCount;
      const message = await response?.mallEntriesByAgent?.message;

      if (success) {
        setMallListData(data);
        setPageCount(totalPages);
      } else {
        setMallListData([]);

        Swal.fire({
          icon: "warning",
          title: "No Data Found",
          text: message || "Mall list data not available.",
          showCloseButton: true,
          confirmButtonColor: "#f0ad4e",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error Fetching Data",
        text: error.message || "Something went wrong while loading mall list.",
        showCloseButton: true,
        confirmButtonColor: "#d33",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchallusers = async () => {
    try {
      const response = await request(BASEURL, allUsers);

      if (response.allUsers) {
        let allagents = response.allUsers;
        allagents = allagents.map((agent) => ({
          value: agent?.id,
          label: agent?.employeeName,
        }));
        setAllagentsOptions(allagents);
      }
    } catch (error) {
      setAllagentsOptions([]);
    }
  };

  const handleChange = (event, value) => {
    setCurrentPage(value);
    fetchMallListData(value);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleDelte = (id) => {
    Swal.fire({
      title: "Are you sure you want to delete this data?",
      text: "This action is irreversible and cannot be recovered.",
      icon: "question",
      showCancelButton: true,
    }).then(async (result) => {
      if (result?.isConfirmed) {
        setCirleLoading(true);
        try {
          const res = await request(BASEURL, deletemall, {
            id: id,
          });
          const success = res?.deleteMallEntry?.success;
          const message = res?.deleteMallEntry?.message;
          if (success) {
            Swal.fire({
              position: "top",
              icon: "success",
              title: message,
              showConfirmButton: true,
            }).then(() => {
              if (tabValue == "myentry") {
                fetchMallListByUser(currentPage);
              } else {
                fetchMallListData(currentPage);
              }
            });
          } else {
            Swal.fire({
              position: "top",
              icon: "error",
              title: message,
              showConfirmButton: true,
            });
          }
        } catch (err) {
        } finally {
          setCirleLoading(false);
        }
      }
    });
  };

  const submitreconcile = () => {};

  const handleRecoildialog = (value, item) => {
    setRecoilData(item);

    setRecoilType(value);
    setRecoilOpen(true);
  };
  const handleSearchChange = (value) => {
    setCurrentPage(1);
    setSearchValue(value);

    if (tabValue === "myentry") {
      fetchMallListByUser(1, value);
    } else {
      fetchMallListData(1, value);
    }
  };

  return (
    <div className="Productdisplaycontainer">
      <RemarksDialog
        open={remarksOpen}
        setOpen={setRemarksOpen}
        productDatas={datas}
        setProductDatas={setDatas}
        tabValue={tabValue}
        fetchMallListData={fetchMallListData}
      />
      <AgreedProductPopUp
        open={agreenProductOpen}
        setOpen={setAgreenProductOpen}
        productDatas={datas}
        setProductDatas={setDatas}
        fetchMallListData={fetchMallListData}
        tabValue={tabValue}
      />
      <ReconcileDialog
        open={recoilOpen}
        onClose={() => setRecoilOpen(false)}
        onSubmit={submitreconcile}
        type={recoilType}
        data={recoilData}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "end",
          flexWrap: "wrap",
          gap: "4px",
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              background: "#f9f9f9",
              border: "1px solid #ccc",
              borderRadius: "8px",
              padding: "0px 12px",
              width: "100%",
              height: "50px",
              maxWidth: "300px",
            }}
          >
            <FiSearch
              style={{ color: "#888", marginRight: "8px", fontSize: "18px" }}
            />
            <input
              type="text"
              placeholder="Search..."
              value={searchValue}
              onChange={(e) => handleSearchChange(e.target.value)}
              style={{
                border: "none",
                outline: "none",
                flex: 1,
                fontSize: "15px",
                background: "transparent",
              }}
            />
          </div>
        </div>

        {tabValue !== "myentry" && (
          <Grid container spacing={2} alignItems="center" sx={{}}>
            <Grid item xs={12} sm={3} md={3} lg={4}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  From Date
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                type="date"
                name="startDate"
                value={filterData?.startDate}
                onChange={(e) =>
                  dispatch({ value: e?.target?.value, name: "startDate" })
                }
                inputProps={{
                  max: new Date().toISOString().split("T")[0],
                }}
                fullWidth
                sx={{ height: "38px" }}
              />
            </Grid>

            <Grid item xs={12} sm={3} md={3} lg={4}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  To Date
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                type="date"
                name="endDate"
                value={filterData?.endDate}
                onChange={(e) =>
                  dispatch({ value: e?.target?.value, name: "endDate" })
                }
                inputProps={{
                  max: new Date().toISOString().split("T")[0],
                  min: filterData?.startDate || undefined,
                }}
                fullWidth
                sx={{ height: "38px" }}
              />
            </Grid>

            <Grid item xs={12} sm={3} md={3} lg={4}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Agent <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="agentId"
                value={filterData?.agentId}
                customStyles={{ optionPadding: 20 }}
                options={allagentsOptions}
                onChange={(e) => dispatch({ value: e, name: "agentId" })}
                isClearable
                styles={{
                  control: (base) => ({
                    ...base,
                    height: "38px",
                    minHeight: "38px",
                  }),
                }}
              />
            </Grid>
          </Grid>
        )}
      </div>

      {!isLoading ? (
        <>
          {mallListData && mallListData.length > 0 ? (
            <>
              {mallListData.map((v, i) => (
                <ProductDisplayMall
                  key={i}
                  id={v?.id}
                  marketName={v?.marketName}
                  address={v?.address}
                  agreedProducts={v?.agreedProducts}
                  contactPerson={v?.contactPerson}
                  contactNumber={v?.contactNumber}
                  contractStart={v?.contractStart}
                  contractEnd={v?.contractEnd}
                  completeWithin={v?.completeWithin}
                  agentName={v?.agent?.employeeName}
                  agentCode={v?.agent?.employeeCode}
                  agreenProductOpen={agreenProductOpen}
                  setAgreenProductOpen={setAgreenProductOpen}
                  remarksOpen={remarksOpen}
                  setRemarksOpen={setRemarksOpen}
                  setDatas={setDatas}
                  datas={datas}
                  handleDeleteMall={handleDelte}
                  tabValue={tabValue}
                  handleRecoildialog={handleRecoildialog}
                />
              ))}

              <Pagination
                count={pageCount}
                page={currentPage}
                variant="outlined"
                shape="rounded"
                onChange={handleChange}
              />
            </>
          ) : (
            // 👇 Inline UI for no data
            <Box
              sx={{
                width: "100%",
                textAlign: "center",
                py: 5,
                bgcolor: "#f9f9f9",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Typography variant="h6" color="text.secondary">
                No Product Compliance Data Found
              </Typography>
            </Box>
          )}
        </>
      ) : (
        [...Array(5)].map((_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            width="100%"
            height={60}
            sx={{ borderRadius: "5px", margin: "5px 0px" }}
          />
        ))
      )}
    </div>
  );
};

export default ProductDisplayComplianceNew;
